import React, { ReactNode, useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import Header from "./components/header/Header";
import Main from "./components/main/Main";
import Footer from "./components/footer/Footer";
import Privacy from "./pages/privacy/Privacy";
import { Routes, Route, Link, BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import FeatureDetailModule from "./components/FeatureDetail";
import AboutUs from "./pages/AboutUs";
import {useTranslation} from "react-i18next";
import AboutUsEN from "./pages/AboutUs/index-en";

interface LanguageWrapperProps {
  children: ReactNode;
}

const LanguageWrapper: React.FC<LanguageWrapperProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const path = location.pathname;
  const allowedLanguages = ['en', 'zh'];

  useEffect(() => {
    console.log("currentLang", currentLang)
    console.log("allowedLanguages", allowedLanguages)
    const langInPath = allowedLanguages.find(lang => path.startsWith(`/${lang}/`));
    if (!langInPath) {
      navigate(`/${currentLang}${path}`, { replace: true });
    } else if(langInPath !== currentLang) {
      i18n.changeLanguage(langInPath);
    }
  }, [currentLang, navigate, path, allowedLanguages]);

  return <>{children}</>;
};

function App() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  return (
    <div className="App">
      <Header></Header>
      <BrowserRouter>
        <LanguageWrapper>
          <Routes>
            <Route path="/:lang/" element={<Main />} />
            <Route path="/:lang/privacy" element={<Privacy />} />
            <Route path="/:lang/about" element={currentLang == 'zh' ? <AboutUs /> : <AboutUsEN/> } />
            <Route path="/:lang/feature-detail/:id" element={<FeatureDetailModule />} />
          </Routes>
        </LanguageWrapper>
      </BrowserRouter>
      <Footer></Footer>
    </div>
  );
}

export default App;

